// ---------------------- PRODUCT VALUES ---------------------- //
export const ALL_DATA_VALUE = 'all';
export const JOURNEYS_VALUE = 'journeys';
export const QUICK_LINKS_VALUE = 'quick-links';
export const UNIVERSAL_ADS_VALUE = 'universal-ads';
export const UNIVERSAL_EMAIL_VALUE = 'universal-email';
export const OTT_VALUE = 'ott';

export const ALL_PRODUCTS = [
  ALL_DATA_VALUE,
  JOURNEYS_VALUE,
  QUICK_LINKS_VALUE,
  UNIVERSAL_ADS_VALUE,
  UNIVERSAL_EMAIL_VALUE,
] as const;

// ---------------------- OTHER ---------------------- //
export const OLD_SUMMARY_TILE_CONTEXT_KEY = 'tileConfig';
